var _module_exports ="<div class=\"row nopadding\">\n    <div ui-view></div>\n</div>";;
var path = '/app/Main/systemOwnerReview/MainSystemOwnerReview.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;